import _ from 'lodash';
import { useCallback, useEffect, useMemo, useState } from 'react';

const useDebouncedText = ({ searchText, fieldList }) => {
  const [debouncedText, setDebouncedText] = useState('');

  const debouncedSearchText = useCallback(
    _.debounce(value => setDebouncedText(value), 300),
    []
  );

  useEffect(() => {
    debouncedSearchText(searchText);
  }, [searchText, debouncedSearchText]);

  const getFilteredList = useMemo(() => {
    if (!debouncedText) {
      return fieldList;
    }
    return fieldList.filter(field => {
      const { name, address, address2 } = field;
      const lowerSearchText = debouncedText.toLowerCase();
      return name?.toLowerCase().includes(lowerSearchText) || address?.toLowerCase().includes(lowerSearchText) || address2?.toLowerCase().includes(lowerSearchText);
    });
  }, [debouncedText, fieldList]);

  return { getFilteredList };
};

export default useDebouncedText;
